import React from 'react'
import { func, shape, number } from 'prop-types'
import { translate } from 'react-i18next'

import { Price } from '../ui/inputs/Price'
import { Accordion } from '../accordion/Accordion'
// Kept commented along with the card top-up accordion below
// import CreditCardPaymentContent from '../customer/wallet/payments/credit/CreditCardPaymentContent'
import TransfertPaymentContent from '../customer/wallet/payments/transfert/TransfertPaymentContent'
import CesuPaymentContent from '../customer/wallet/payments/cesu/CesuPaymentContent'
import ChequePaymentContent from '../customer/wallet/payments/cheque/ChequePaymentContent'

import './PaymentDescription.css'

export const PaymentDescription = translate()(({ t, cards, payment, iban }) => (
  <div>
    <div className='payment__header clearfix'>
      <div className='payment__secure'>
        <div><img className='' src='/app/images/cadenas.png' alt='lock' /></div>
        <div>{t('common:payment:secure')}</div>
      </div>
      <div className='payment__means' style={{ display: cards ? '' : 'none' }}>
        <img className='' src='/app/images/discover_card.png' alt='' />
        <img className='' src='/app/images/credit_card.png' alt='' />
        <img className='' src='/app/images/visa.png' alt='' />
      </div>
    </div>
    {!cards &&
    <div className='payments_container'>
      <span className='payments_title'>{t('common:payment:instruction')}</span>
      <div className='payments-list'>
        {/*
          This list answers "how do I top up my CMJ account". Card is no longer one of the answers
          since the Lemonway -> Axepta migration: paying by card settles the quote directly and
          never credits the account. Leaving it here promised a top-up that cannot happen.
          Paying a quote BY CARD is of course still offered, on the payment screen itself.
          <Accordion title={t('common:payment:possibilities:credit_card')} additionalComponent={<CreditCardPaymentContent />} />
        */}
        <Accordion title={t('common:payment:possibilities:transfert')} additionalComponent={<TransfertPaymentContent walletIban={iban} />} />
        <Accordion title={t('common:payment:possibilities:cheque')} additionalComponent={<ChequePaymentContent />} />
        <Accordion title={t('common:payment:possibilities:cesu')} additionalComponent={<CesuPaymentContent />} />
      </div>
    </div>
    }
    <div className='paiement__body__invoice'>
      <div className='paiement__body__invoice__line paiement__body__invoice__line--total'>
        <div className='paiement__body__invoice__line__item'>
          {t('common:payment:total_line')}
        </div>
        <div className='paiement__body__invoice__line__item'>
          <Price value={payment.total} />
        </div>
      </div>
      {
        payment.advance > 0
        ? (
          <div className='paiement__body__invoice__line paiement__body__invoice__line--total'>
            <div className='paiement__body__invoice__line__item'>
              {t('common:payment:total_advance')}
            </div>
            <div className='paiement__body__invoice__line__item'>
              <Price value={payment.advance} />
            </div>
          </div>
        ) : ''
      }
    </div>
  </div>
))

PaymentDescription.propTypes = {
  t: func,
  payment: shape({
    advance: number,
    unpaid: number,
    total: number,
    balance: number
  })
}



// WEBPACK FOOTER //
// ./src/components/payment/PaymentDescription.js